import React, { useEffect, useLayoutEffect, useState } from 'react';
import * as am4core from '@amcharts/amcharts4/core';
import * as am4charts from '@amcharts/amcharts4/charts';
import am4themes_animated from '@amcharts/amcharts4/themes/animated';
import { CHART_MAX_VALUES } from 'constant/variables';

am4core.useTheme(am4themes_animated);

export default function OutletProductChartNew(props) {
  const [viewData, setViewData] = useState([]);
  const { outletper } = props;
  console.log("OutletProductChart Render", outletper, props.region);
  useEffect(() => {
    
    if (outletper) {
      if (outletper.length === 0) {
        const viewDetail = [];
        const details = {
          category: "Not Available",
          hbb: 0,
          hayyak: 0,
          baqati: 0,
          upgrade: 0,
          achievement: 0,
        };
        viewDetail.push(details);
        setViewData(viewDetail);
      } else {
        const clinic = outletper;
        const viewDetail = [];
        let count = 0;
        console.log("OutletProductChart useEffect called", props.region, clinic)
        for (let index = 0; index < clinic.length; index++) {
          if((count + 1) > CHART_MAX_VALUES) {
            break;
          }
          console.log("OutletProductChart for loop", {index, item: clinic[index], dondition: props.region !== clinic[index].Region})

          if(props.region && props.region !== clinic[index].Region) {

          }else {
            console.log("OutletProductChart for Loop", clinic[index].Region, props.region);
            const details = {
              category: clinic[index].OutletName,
              hbb: clinic[index].HBBSales,
              hayyak: clinic[index].HayyakSales,
              baqati: clinic[index].BaqatiSales,
              upgrade: clinic[index].UpgradeSales,
              achievement: parseInt(clinic[index].TotalAchievedPercentage),
            };
            count++;
            viewDetail.push(details);
          }
        }
        console.log("OutletProductChart viewDetail", viewDetail)
        setViewData(viewDetail);
      }
    }
  }, [outletper, props.region]);

  const gotoEmployeeChart = (ev) => {
    const columnData = ev.target._dataItem?._dataContext || {};
    props.onSelect(columnData.category);
    document.getElementById('employeeTargetId').scrollIntoView({
        behavior: 'smooth'
      })
}


  useLayoutEffect(() => {
    
    let chart = am4core.create("outletProductChart", am4charts.XYChart);


    // Add data
chart.data = [{
  "date": "Outlet 1",
  "market1": 71,
  "market2": 75,
  "sales1": 50,
  "sales2": 8,
  sales3: 100,
}, {
  "date": "Outlet 2",
  "market1": 74,
  "market2": 78,
  "sales1": 40,
  "sales2": 6,
  sales3: 30,
}, {
  "date": "Outlet 3",
  "market1": 78,
  "market2": 88,
  "sales1": 50,
  "sales2": 2,
  sales3: 80,
}, {
  "date": "Outlet 4",
  "market1": 85,
  "market2": 89,
  "sales1": 80,
  "sales2": 9,
  sales3: 60,
}, {
  "date": "Outlet 5",
  "market1": 82,
  "market2": 89,
  "sales1": 90,
  "sales2": 6,
  sales3: 40,
}, {
  "date": "Outlet 6",
  "market1": 83,
  "market2": 85,
  "sales1": 30,
  "sales2": 5,
  sales3: 20,
}, {
  "date": "Outlet 7",
  "market1": 88,
  "market2": 92,
  "sales1": 50,
  "sales2": 7,
  sales3: 60,
}, {
  "date": "Outlet 8",
  "market1": 85,
  "market2": 90,
  "sales1": 70,
  "sales2": 6,
  sales3: 20,
}, {
  "date": "Outlet 9",
  "market1": 85,
  "market2": 91,
  "sales1": 90,
  "sales2": 5,
  sales3: 10,
}, {
  "date": "Outlet 10",
  "market1": 80,
  "market2": 84,
  "sales1": 5,
  "sales2": 8,
  sales3: 40,
}, {
  "date": "Outlet 11",
  "market1": 87,
  "market2": 92,
  "sales1": 40,
  "sales2": 8,
  sales3: 20,
}, {
  "date": "Outlet 12",
  "market1": 84,
  "market2": 87,
  "sales1": 30,
  "sales2": 4,
  sales3: 30,
}, {
  "date": "Outlet 13",
  "market1": 83,
  "market2": 88,
  "sales1": 50,
  "sales2": 7,
  sales3: 50,
}, {
  "date": "Outlet 14",
  "market1": 84,
  "market2": 87,
  "sales1": 50,
  "sales2": 8,
  sales3: 10,
}, {
  "date": "Outlet 15",
  "market1": 81,
  "market2": 85,
  "sales1": 90,
  "sales2": 7,
  sales3: 50,
}];



// Create axes
let dateAxis = chart.xAxes.push(new am4charts.DateAxis());
//dateAxis.renderer.grid.template.location = 0;
//dateAxis.renderer.minGridDistance = 30;

let valueAxis1 = chart.yAxes.push(new am4charts.ValueAxis());
valueAxis1.title.text = "Sales";

let valueAxis2 = chart.yAxes.push(new am4charts.ValueAxis());
valueAxis2.title.text = "Market Days";
// valueAxis2.renderer.opposite = true;
valueAxis2.renderer.grid.template.disabled = true;

// Create series
let series1 = chart.series.push(new am4charts.ColumnSeries());
series1.dataFields.valueY = "sales1";
series1.dataFields.dateX = "date";
series1.yAxis = valueAxis1;
series1.name = "Target Sales";
series1.tooltipText = "{name}\n[bold font-size: 20]${valueY}M[/]";
series1.fill = chart.colors.getIndex(0);
series1.strokeWidth = 0;
series1.clustered = false;
series1.columns.template.width = am4core.percent(40);

function createSeries(value, name) {
  var series = chart.series.push(new am4charts.ColumnSeries())
  series.dataFields.valueY = value
  series.dataFields.dateX = 'date'
  series.name = name
  series.columns.template.width = am4core.percent(40);
  // series.clustered = true;
  var bullet = series.bullets.push(new am4charts.LabelBullet())
  bullet.interactionsEnabled = false
  bullet.dy = 30;
  bullet.label.text =  "{name}\n[bold font-size: 20]${valueY}M[/]";
  bullet.label.fill = am4core.color('#ffffff')

  series.columns.template.column.cornerRadiusTopLeft = 10;
  series.columns.template.column.cornerRadiusTopRight = 10;
  series.columns.template.column.fillOpacity = 0.8;
  series.columns.template.strokeWidth = 0;

  series.columns.template.tooltipText = "{name}: {valueY}";

  return series;
}

createSeries('sales3', 'Seriesb 6');

// let series6 = chart.series.push(new am4charts.ColumnSeries());
// series6.dataFields.valueY = "sales3";
// series6.dataFields.dateX = "date";
// series6.yAxis = valueAxis1;
// series6.name = "Sales 3";
// series6.tooltipText = "{name}\n[bold font-size: 20]${valueY}M[/]";
// series6.fill = new am4core.InterfaceColorSet().getFor(
//   'alternativeBackground'
// );
// series6.strokeWidth = 0;
// series6.clustered = false;
// series6.columns.template.width = am4core.percent(40);

let series2 = chart.series.push(new am4charts.ColumnSeries());
series2.dataFields.valueY = "sales2";
series2.dataFields.dateX = "date";
series2.yAxis = valueAxis1;
series2.name = "Actual Sales";
series2.tooltipText = "{name}\n[bold font-size: 20]${valueY}M[/]";
series2.fill = chart.colors.getIndex(0).lighten(0.5);
series2.strokeWidth = 0;
series2.clustered = false;
series2.toBack();

let series3 = chart.series.push(new am4charts.LineSeries());
series3.dataFields.valueY = "market1";
series3.dataFields.dateX = "date";
series3.name = "Market Days";
series3.strokeWidth = 2;
series3.tensionX = 0.7;
series3.yAxis = valueAxis2;
series3.tooltipText = "{name}\n[bold font-size: 20]{valueY}[/]";

let bullet3 = series3.bullets.push(new am4charts.CircleBullet());
bullet3.circle.radius = 3;
bullet3.circle.strokeWidth = 2;
bullet3.circle.fill = am4core.color("#fff");

// Add cursor
chart.cursor = new am4charts.XYCursor();

// Add legend
chart.legend = new am4charts.Legend();
chart.legend.position = "top";

// Add scrollbar
chart.scrollbarX = new am4charts.XYChartScrollbar();
chart.scrollbarX.series.push(series1);
chart.scrollbarX.series.push(series3);
// chart.scrollbarX.series.push(series6);
chart.scrollbarX.parent = chart.bottomAxesContainer;

    return () => {
      chart.dispose();
    };
  }, [viewData]);

  return <div id="outletProductChart" style={{ width: '100%', height: '500px', direction: "ltr" }} />;
}
